import { cva } from 'class-variance-authority';

export const goodieCardVariants = cva(
  'flex flex-col gap-4 p-4 w-[173px] h-[250px] rounded-3xl border border-white/10 bg-[linear-gradient(141.57deg,rgba(255,255,255,0.25)_5.75%,rgba(0,0,0,0)_94.25%),linear-gradient(0deg,rgba(255,255,255,0.05),rgba(255,255,255,0.05))]',
);
